import React from 'react';
import { CardWrapper } from './Card.style';
import { icons, layouts } from 'seal-ui-components';

const { HorizontalBox, VerticalBox, BoxSpacer } = layouts;
const { ChevronUpSmallIcon, ChevronDownSmallIcon } = icons;

/* eslint-disable  no-empty-function */

const Card = ({
    children,
    color,
    collapsible,
    toggle = () => {},
    isOpened,
    renderHeader = () => {},
    stackEffect,
    hideControls,
    ...rest
}) => {
    const toggleCard = () => {
        if (hideControls) return;

        toggle();
    };
    return (
        <>
            <CardWrapper color={color} isOpened={isOpened} stackEffect={stackEffect} {...rest}>
                {collapsible ? (
                    <>
                        <HorizontalBox
                            className="collapsible-panel"
                            data-testid="control-collapse"
                            onClick={toggleCard}
                        >
                            {renderHeader()}
                            <BoxSpacer />
                            {hideControls ? null : isOpened ? (
                                <VerticalBox
                                    data-testid="close-icon"
                                    className="collapsible-panel__toggler"
                                >
                                    <ChevronDownSmallIcon />
                                    <ChevronUpSmallIcon />
                                </VerticalBox>
                            ) : (
                                <VerticalBox
                                    data-testid="open-icon"
                                    className="collapsible-panel__toggler"
                                >
                                    <ChevronUpSmallIcon />
                                    <ChevronDownSmallIcon />
                                </VerticalBox>
                            )}
                        </HorizontalBox>
                        {isOpened && <div className="collapsible-text">{children}</div>}
                    </>
                ) : (
                    <>{children}</>
                )}
            </CardWrapper>
        </>
    );
};

export default Card;
